export default "__VITE_ASSET__BjPp3my2__"